import { types } from 'mobx-state-tree'

const CountryModel = types.model('CountryModel', {
  id: types.maybeNull(types.number),
  name: types.maybeNull(types.string),
})

export default CountryModel
